import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';

import './styles.scss';

const ContentTab = ({ children }: { children: ReactNode }) => {
  return <div className='c-ContentTab'>
    {
      children
    }
  </div>;
};


export default observer(ContentTab);
